import React from 'react';
import { AccountInfo } from '../../services/reportApi';

interface AccountSummaryCardProps {
    account: AccountInfo;
}

const AccountSummaryCard: React.FC<AccountSummaryCardProps> = ({ account }) => {
    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    };

    const formatPercent = (value: number) => {
        const sign = value >= 0 ? '+' : '';
        return `${sign}${value.toFixed(2)}%`;
    };

    return (
        <section className="section">
            <h2>계좌 현황</h2>
            <div className="account-grid">
                <div className="account-stat">
                    <span className="label">총 자산</span>
                    <span className="value">{formatCurrency(account.total_value)}</span>
                </div>
                <div className="account-stat">
                    <span className="label">현금</span>
                    <span className="value">{formatCurrency(account.cash)}</span>
                </div>
                <div className="account-stat">
                    <span className="label">매수력</span>
                    <span className="value">{formatCurrency(account.buying_power)}</span>
                </div>
                <div className="account-stat daily-return">
                    <span className="label">일일 수익률</span>
                    <span
                        className={`value ${account.daily_return_percent >= 0 ? 'positive' : 'negative'
                            }`}
                    >
                        {formatPercent(account.daily_return_percent)}
                        <span className="amount">({formatCurrency(account.daily_return_amount)})</span>
                    </span>
                </div>
            </div>
        </section>
    );
};

export default AccountSummaryCard;
